import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ProgressBar from 'react-bootstrap/ProgressBar';
import toast from 'react-hot-toast';
import { checkZipExtension } from '../../settings/shared/commonMethods';
import StorageService from '../../services/api/Storage';
import axios from 'axios'
import FileJobsService from '../../services/api/FileJobs';
import { cloudTypes } from '../../settings/shared/constants'
import axiosClient from '../../services/common';
import { Button, Form, FormControl, FormGroup, FormLabel, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';

const DROPFILE_CSS = `
  .dfi-drop {
    border: 1px dashed rgba(0,0,0,0.14);
    border-radius: 14px;
    background: rgba(37,99,235,0.03);
    transition: border-color 0.12s, background 0.12s, transform 0.12s;
  }
  .dfi-drop.dragover {
    border-color: rgba(37,99,235,0.55);
    background: rgba(37,99,235,0.07);
    transform: translateY(-1px);
  }
  .dfi-drop .drag-area {
    padding: 18px;
    text-align: center;
  }
  .dfi-drop .drag-area .icon {
    width: 44px;
    height: 44px;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(37,99,235,0.10);
    color: #1d4ed8;
    margin-bottom: 10px;
    font-size: 18px;
  }
  .dfi-drop .drag-area .header {
    display: block;
    font-weight: 700;
    font-size: 13px;
    color: rgba(17,17,16,0.9);
    line-height: 1.35;
  }
  .dfi-drop .drag-area .button {
    color: #2563eb;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
  .dfi-note {
    font-size: 12px;
    color: rgba(107,107,104,1);
  }
  .dfi-modal-sub {
    font-size: 12px;
    color: rgba(107,107,104,1);
    margin-top: 6px;
  }
  .dfi-count {
    font-size: 11.5px;
    color: rgba(107,107,104,1);
  }

  /* ── Upload list / preview ── */
  .drop-file-preview__title {
    font-size: 12px;
    font-weight: 700;
    color: rgba(17,17,16,0.9);
    margin: 12px 0 8px;
  }

  .drop-file-preview__item {
    position: relative;
    display: grid;
    grid-template-columns: 34px 1fr auto;
    gap: 10px;
    align-items: center;
    padding: 10px 10px 12px;
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 12px;
    background: #fff;
    margin-bottom: 10px;
  }

  .drop-file-preview__item .zip-align {
    width: 34px;
    height: 34px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(217,119,6,0.12);
    color: #b45309;
    font-size: 14px;
  }

  .drop-file-preview__item__info {
    min-width: 0;
  }

  .drop-file-preview__item__info .label {
    margin: 0;
    font-size: 12.5px;
    font-weight: 700;
    color: rgba(17,17,16,0.92);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .drop-file-preview__item__info .size {
    margin: 2px 0 0;
    font-size: 11.5px;
    color: rgba(107,107,104,1);
  }

  .dfi-remove {
    width: 30px;
    height: 30px;
    border-radius: 10px;
    border: 1px solid rgba(0,0,0,0.08);
    background: rgba(0,0,0,0.02);
    color: rgba(107,107,104,1);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.12s, border-color 0.12s, color 0.12s;
  }
  .dfi-remove:hover { background: rgba(220,38,38,0.08); border-color: rgba(220,38,38,0.18); color: #dc2626; }

  .drop-file-preview__item .progress {
    grid-column: 1 / -1;
    height: 8px;
    border-radius: 999px;
    background: rgba(37,99,235,0.10);
    overflow: hidden;
    margin-top: 6px;
  }

  .drop-file-preview__item .progress-bar {
    background: linear-gradient(90deg, #2563eb, #7c3aed);
  }

  .dfi-progress-row {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;
  }

  .dfi-progress-row .dfi-progress-text {
    font-size: 11.5px;
    color: rgba(107,107,104,1);
    font-weight: 650;
  }
`;

const DropFileInput = props => {

    const wrapperRef = useRef(null);

    const [fileList, setFileList] = useState([]);

    const [upPercentage, setUpPercentage] = useState(0)

    const [errorMessage, setErrorMessage] = useState("")

    const [show, setShow] = useState(false);

    const [comments, setComments] = useState(null);
    const formatBytes = (bytes) => {
        const n = Number(bytes);
        if (!Number.isFinite(n) || n <= 0) return "0 B";
        const units = ["B", "KB", "MB", "GB", "TB"];
        const i = Math.min(units.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
        const v = n / Math.pow(1024, i);
        return `${v >= 10 || i === 0 ? v.toFixed(0) : v.toFixed(1)} ${units[i]}`;
    };
    const MAX_COMMENT_LEN = 500;

    useEffect(() => {
        const id = "dropfile-input-styles-v2";
        const existing = document.getElementById(id);
        if (!existing) {
            const tag = document.createElement("style");
            tag.id = id;
            tag.textContent = DROPFILE_CSS;
            document.head.appendChild(tag);
        } else {
            existing.textContent = DROPFILE_CSS;
        }
    }, []);

    const onDragEnter = () => wrapperRef.current.classList.add('dragover');

    const onDragLeave = () => wrapperRef.current.classList.remove('dragover');

    const onDrop = () => wrapperRef.current.classList.remove('dragover');

    const onFileDrop = (e) => {
        const newFile = e.target.files[0];
        if (newFile) {
            // If the uploadType is "app", call the zip file upload
            if (props?.uploadType === "app") {
                if (checkZipExtension(newFile?.name)) {
                    handleFileUpload(newFile);
                } else {
                    setErrorMessage(`You can upload only ${props?.acceptFileType} files. Other formats are not supported.`);
                }
            } else {
                // If uploadType is not "app" Call general upload
                handleFileUpload(newFile);
            }
        }
    };

    const handleChange = (event) => {
        if (event) {
            setComments(event.target.value?.slice(0, MAX_COMMENT_LEN))
        }
    }
    
    const handleFileUpload = (file) => {
        setErrorMessage("");
        const updatedList = [...fileList, file];
        setFileList(updatedList);
        document.getElementById("file-upload-store").value = ""
        setShow(true)
    };

    const uploadInititate = () => {
        setShow(false)
        if (!fileList?.length) return;

        const file = fileList[fileList?.length - 1];
        const {
            sourceInfo,
            prefix,
            storageId,
            rootFolder
        } = props;

        const filePath = sourceInfo || `${prefix}${file.name}`;

        uploadFile(filePath, file, storageId, rootFolder, comments);
    };

    const onUploadSuccess = (savefiledata) => {
        // If caller manages versioning + closing, delegate to that flow.
        if (props.saveVersion) {
            saveVersion(savefiledata);
            return;
        }
        toast.success("File uploaded successfully");
        setTimeout(() => {
            props?._reloadVersion?.();
            setFileList([]);
            setComments(null);
            setUpPercentage(0);
        }, 500);
        closeMoalBox();
    };


    const saveVersion = (savefiledata) => {
        if (props.saveVersion) {
            FileJobsService.saveVersion(savefiledata)
                .then((response) => {
                    toast.success("File Uploaded and New Version Create Successfully");
                    closeMoalBox();
                    setTimeout(() =>{
                        props?._reloadVersion();
                        setFileList([])
                    },1000)
                });
        }
    }

    const uploadFile = (info, fileContent, storageName, rootFolder, savecomments) => {
        let contentType = 'application/octet-stream'
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        let filePath = info?.name ? info?.name : info;
        let appId = info?.id
        StorageService.uploadObjectUrl(props?.uploadType, filePath, storageName, rootFolder)
            .then((response) => {
                let savefiledata = {
                    id: appId,
                    comments: savecomments !== undefined && savecomments !== null ? savecomments : ""
                }
                if (response.type === cloudTypes.GOOGLE) {
                    axios({
                        url: response.upload_url,
                        baseURL: '',
                        data: {},
                        headers: {
                            'content-type': contentType,
                            'x-goog-resumable': 'start'
                        },
                        method: 'POST',
                        cancelToken: source.token
                    }).then((resp) => {
                        const resumableLink = resp.headers.location
                        axiosClient({
                            url: resumableLink,
                            baseURL: '',
                            data: JSON.stringify(fileContent),
                            headers: {
                                'content-type': "multipart/form-data"
                            },
                            method: 'PUT',
                            cancelToken: source.token,
                            onUploadProgress: (progressEvent) => {
                                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUpPercentage(percent)
                        }
                        }).then((resp) => {
                            onUploadSuccess(savefiledata);
                        })
    
                    });
    
                } else if (response.type === cloudTypes.AWS) {
                    var rest = response.fields;
                    var formData = new FormData();
                    for (const [key, value] of Object.entries(rest)) {
                        formData.append(key, value)
                    }
                    formData.append("file", fileContent)
                    axios({
                        url: response.upload_url,
                        data: formData,
                        headers: {
                            'content-type': "multipart/form-data"
                        },
                        method: 'POST',
                        cancelToken: source.token,
                        onUploadProgress: (progressEvent) => {
                                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUpPercentage(percent)
                        }
                    }).then((resp) => {
                        onUploadSuccess(savefiledata);
                    })
                } else if (response.type === cloudTypes.AZURE) {
                    axios({
                        url: response.upload_url,
                        data: JSON.stringify(fileContent),
                        headers: {
                            'content-type': "multipart/form-data",
                            'x-ms-blob-type': 'BlockBlob'
                        },
                        method: 'PUT',
                        cancelToken: source.token,
                        onUploadProgress: (progressEvent) => {
                            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setUpPercentage(percent)
                    }
                    }).then((resp) => {
                        onUploadSuccess(savefiledata);
                    })
                }
    
            });
    }

    const closeMoalBox = () =>{
        setTimeout(() => {
            props?.closeModal && props?.closeModal()
        },3000)
    }

    const fileRemove = (file) => {
        const updatedList = [...fileList];
        updatedList.splice(fileList.indexOf(file), 1);
        setFileList(updatedList);
    }

    return (
        <>
            {errorMessage && <div className='bg-error-red'>
                <span className='txt-white'>{errorMessage}</span>
            </div>}
            <div
                ref={wrapperRef}
                className="drop-file-input dfi-drop"
                onDragEnter={onDragEnter}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                
                <div className='drag-area'>
                    <div className="icon">
                        <i className="fa-solid fa-cloud-arrow-up"></i>
                    </div>
                    <span className="header">Drag & drop to upload</span>
                    <span className="header">or <span className="button">browse</span></span>
                    <input type="file" id='file-upload-store' accept={props?.acceptFileType} onChange={(e) => onFileDrop(e)} />
                </div>
            </div>
            {props?.acceptFileType && (
                <div className="dfi-note pb-2">
                    Note: You can upload only {props?.acceptFileType} files. Other formats are not supported.
                </div>
            )}

            {
                fileList.length > 0 ? (
                    <div className="drop-file-preview">
                        <p className="drop-file-preview__title">
                            Uploaded Files:
                        </p>
                        {
                            fileList.map((item, index) => (
                                    <div key={index} className="drop-file-preview__item">
                                        <i className="fa-solid fa-file-zipper zip-align"></i>
                                        <div className="drop-file-preview__item__info">
                                            <p className='label'>
                                                {item.name}
                                                {upPercentage === 100 && <i className="fa-solid fa-circle-check txt-green" aria-label="Uploaded" />}
                                            </p>
                                            <p className='size'>{formatBytes(item.size)}</p>
                                        </div>

                                        <button
                                            type="button"
                                            className="dfi-remove"
                                            onClick={() => fileRemove(item)}
                                            aria-label="Remove file"
                                            title="Remove"
                                        >
                                            <i className="fa-solid fa-xmark" />
                                        </button>

                                        <ProgressBar min={0} max={100} now={upPercentage} />
                                        <div className="dfi-progress-row">
                                            <span className="dfi-progress-text">{upPercentage}%</span>
                                            <span className="dfi-progress-text">
                                                {upPercentage === 100 ? "Done" : "Uploading…"}
                                            </span>
                                        </div>
                                    </div>
                         ))
                        }
                    </div>
                ) : null
            }

            <Modal 
                show={show}
                onHide={(e) => setShow(false)}
                centered
            >
                <ModalHeader closeButton>
                    <ModalTitle>Add a comment</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="dfi-modal-sub">
                        This note will be saved with the upload{fileList?.length ? ` (${fileList[fileList.length - 1]?.name})` : ""}.
                    </div>
                    <FormGroup className="mt-3">
                        <FormLabel className="mb-1">Comment (optional)</FormLabel>
                        <FormControl
                            as="textarea"
                            rows={4}
                            value={comments || ""}
                            placeholder="What changed in this file? (e.g., fixed config, added assets, updated workflow)…"
                            onChange={handleChange}
                            autoFocus
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <div className="dfi-count me-auto">
                        {(comments?.length || 0)}/{MAX_COMMENT_LEN}
                    </div>
                    <Button variant="light" onClick={(e) => setShow(false)}>
                        Skip
                    </Button>
                    <Button variant="primary" onClick={(e) => uploadInititate(e)}>
                        Upload
                    </Button>
                </ModalFooter>

            </Modal>
        </>
    );
}

DropFileInput.propTypes = {
    onFileChange: PropTypes.func
}

export default DropFileInput;